export default {
    parametros: {
        cliente: '',
        extensoesVirtualizacao: '',
    }
}
